<script>
import { onThemeVariantChange, PhxLightbox } from '@phx-styleguides/als';
import LightBoxMixin from '@phoenix/mixins/components/product/LightBoxMixin';

export default {
  components: {
    PhxLightbox,
  },

  mixins: [LightBoxMixin],

  props: {
    variantItems: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentTheme: 'day',
    };
  },

  computed: {
    _items() {
      return this.currentTheme === 'night' && this.variantItems.length > 0 ? this.variantItems : this.items;
    },
  },

  mounted() {
    onThemeVariantChange(({ variant }) => {
      this.currentTheme = variant;
    });
  },
};
</script>

<template>
  <phx-lightbox :id="lightBoxId" teleport-target="teleport-target-panels" :items="_items" :loop="loop" :i18n="i18n" />
</template>
